import { jwtDecode, JwtPayload } from 'jwt-decode';
import { ENV, MIDWAY_LOGIN_URL, MIDWAY_URL, REGION, REGION_CODE } from 'src/core/config/APIConstants';
import { getEnv, getOrigin, getRegion } from 'src/utils/Environment';
import { encodeParams } from 'src/utils/URL';
// @ts-ignore
import { v4 as uuid } from 'uuid';

import { STSClient, AssumeRoleWithWebIdentityCommand, AssumeRoleWithWebIdentityResponse, AssumeRoleCommand } from '@aws-sdk/client-sts';


export const getUserFromMidwayCredentials = ( midwayToken: string ) =>
{
    const jsonPayload = jwtDecode<JwtPayload>( midwayToken );
    console.log(jsonPayload)
    return jsonPayload.sub ?? '';
};

export const getMidwayURL = () =>
{
    const origin = getOrigin();

    const params = {
        scope: 'openid',
        response_type: 'id_token',
        client_id: origin,
        redirect_uri: origin,
        nonce: uuid(),
    };

    return `${MIDWAY_URL}?${encodeParams( params )}`;
};
export const redirectToMidway = () =>
{
    const origin = getOrigin();

    const params = {
        scope: 'openid',
        response_type: 'id_token',
        client_id: origin,
        redirect_uri: window.location.href,
        nonce: uuid(),
    };
    // The expectation for the midway redirect after auth is to pass a single parameter `next` with
    // a sub path and all the query params
    const nextParam = 'next=' + encodeURIComponent( `/SSO/redirect?${encodeParams( params )}` );

    window.location.href = `${MIDWAY_LOGIN_URL}?${nextParam}`;
};

export const getWebIdentityToken = async () =>
{
    const midwayUrl = getMidwayURL();
    const response = await window.fetch( midwayUrl, {
        method: 'GET',
        credentials: 'include',
    } );
    if ( !response.ok )
    {
        if ( response.status === 401 )
        {
            redirectToMidway();
        }
        else
        {
            throw 'Unable to fetch Midway token';
        }
    }
    const webToken = await response.text();
    return webToken;

};


export const fetchCredentials = async (
    WebIdentityToken: string,
): Promise<AssumeRoleWithWebIdentityResponse> =>
{
    const env: ENV = getEnv();
    const region: REGION = getRegion( location.host, env );

    const stsClient = new STSClient( {
        region: REGION_CODE[ region ],
    } );

    const stsRoleResponse = await stsClient.send(
        new AssumeRoleWithWebIdentityCommand( {
            WebIdentityToken,
            RoleArn: 'arn:aws:iam::390844747180:role/NewtonDashboardWebService-AssumeRoleWithWebIdentity-1KevygaQXieH',
            RoleSessionName: getUserFromMidwayCredentials( WebIdentityToken ),
        } ),
    );

    if ( !stsRoleResponse.Credentials )
    {
        throw 'No credential in STS role';
    }

    return stsRoleResponse;
};

export const isAFTXDomain = (): boolean => {
    return window.location.hostname.endsWith('.aftx.amazonoperations.app');
};

let isRedirectingToMenu = false;

export const getAFTXUser = async (): Promise<{ username: string; warehouseId: string } | null> => {
    if (isRedirectingToMenu) {
        return null;
    }

    const { getAFTXUsername, getAFTXWarehouseId, aftxConstants } = await import('@amzn/aftx-common');

    // Frontend: check cookie presence only. Backend validates cryptographically via AftxCookieAuthenticator
    const username = getAFTXUsername(document.cookie);
    const warehouseId = getAFTXWarehouseId(document.cookie);

    if (!username || !warehouseId) {
        isRedirectingToMenu = true;
        const env: ENV = getEnv();
        const menuUrl = env === ENV.DEVELOPMENT || env === ENV.GAMMA || env === ENV.BETA
            ? aftxConstants.DEFAULT_AFTX_INTEG_URL
            : aftxConstants.DEFAULT_AFTX_PROD_URL;
        window.location.href = `${menuUrl}?referrer=${encodeURIComponent(window.location.href)}`;
        return new Promise(() => {});
    }

    return { username, warehouseId };
};

export const getCurrentUser = async (): Promise<{ username: string; warehouseId?: string }> => {
    if (isAFTXDomain()) {
        const aftxUser = await getAFTXUser();
        if (!aftxUser) throw new Error('AFT-X authentication required');
        return { username: aftxUser.username, warehouseId: aftxUser.warehouseId };
    }

    const token = await getWebIdentityToken();
    return { username: getUserFromMidwayCredentials(token) };
};
